"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Locale = void 0;
var Locale;
(function (Locale) {
    Locale[Locale["English"] = 0] = "English";
    Locale[Locale["Japanese"] = 1] = "Japanese";
    Locale[Locale["Katakana"] = 2] = "Katakana";
})(Locale || (exports.Locale = Locale = {}));
//# sourceMappingURL=Locale.js.map